import { styled } from '@mui/material';
import { DayPicker } from 'react-day-picker';

const StyledCalendar = styled(DayPicker)(({ theme }) => ({
  // root styles
  '&.rdp-root': {
    '--rdp-accent-color':
      theme.palette.primary
        .main /* The accent color used for selected days and UI elements. */,
    '--rdp-accent-background-color':
      theme.palette
        .primary[50] /* The accent background color used for selected days and UI elements. */,

    '--rdp-day-height': '40px' /* The height of the day cells. */,
    '--rdp-day-width': '40px' /* The width of the day cells. */,

    '--rdp-day_button-border':
      '1px solid transparent' /* The border of the day cells. */,
    '--rdp-day_button-height': '38px' /* The height of the day cells. */,
    '--rdp-day_button-width': '38px' /* The width of the day cells. */,

    '--rdp-selected-border': '0' /* The border of the selected days. */,
    '--rdp-today-color': 'inherit' /* The color of the today's date. */,

    '--rdp-months-gap':
      '2rem' /* The gap between the months in the multi-month view. */,

    '--rdp-nav_button-height':
      '1.25rem' /* The height of the navigation buttons. */,
    '--rdp-nav_button-width':
      '1.25rem' /* The width of the navigation buttons. */,
    '--rdp-nav-height': '2.5rem' /* The height of the navigation bar. */,

    '--rdp-range_start-color':
      theme.palette.primary[50] /* The color of the range text. */,
    '--rdp-range_start-date-background-color':
      theme.palette
        .primary[600] /* The background color of the date when at the start of the selected range. */,

    '--rdp-range_end-color':
      theme.palette.primary[50] /* The color of the range text. */,
    '--rdp-range_end-date-background-color':
      theme.palette
        .primary[600] /* The background color of the date when at the end of the selected range. */,

    '& .rdp-month_grid': {
      borderCollapse: 'separate',
      borderSpacing: `0 ${theme.spacing(0.5)}`,
      fontFamily: theme.typography.subtitleNumbers.fontFamily,
      fontSize: theme.typography.subtitleNumbers.fontSize,
      fontWeight: theme.typography.subtitleNumbers.fontWeight,
      lineHeight: theme.typography.subtitleNumbers.lineHeight,
    },

    '& .rdp-month_caption': {
      fontWeigth: theme.typography.body1.fontWeight,
      fontSize: theme.typography.body1.fontSize,
      lineHeight: theme.typography.body1.lineHeight,
      color: theme.palette.text.primary,
    },

    '& .rdp-weekday': {
      fontSize: theme.typography.body14.fontSize,
    },

    // today styles
    '& .rdp-today:not(.rdp-outside) .rdp-day_button': {
      textDecoration: 'underline',
      textDecorationColor: theme.palette.primary.main,
      textUnderlineOffset: '4px',
      textDecorationThickness: '2px',
    },

    '& .rdp-today:not(.rdp-outside).rdp-selected:not(.rdp-range_middle) .rdp-day_button':
      {
        textDecorationColor: theme.palette.primary[50],
      },

    // selected styles
    '& .rdp-selected': {
      fontWeight: 'inherit',
      fontSize: 'inherit',
    },

    '& .rdp-selected:not(.rdp-range_middle, .rdp-range_start, .rdp-range_end) .rdp-day_button':
      {
        backgroundColor: theme.palette.primary[600],
        color: theme.palette.primary[50],
      },

    '& .rdp-selected:not(.rdp-hidden):first-of-type': {
      borderTopLeftRadius: '50%',
      borderBottomLeftRadius: '50%',
    },

    '& .rdp-selected:not(.rdp-hidden):last-of-type': {
      borderTopRightRadius: '50%',
      borderBottomRightRadius: '50%',
    },

    '& td.rdp-hidden + td.rdp-selected:not(.rdp-hidden)': {
      borderTopLeftRadius: '50%',
      borderBottomLeftRadius: '50%',
    },

    '& .rdp-selected:has(+ .rdp-hidden)': {
      borderTopRightRadius: '50%',
      borderBottomRightRadius: '50%',
    },

    '& .rdp-chevron': {
      fill: theme.palette.text.secondary,
    },
  },
}));

export default StyledCalendar;
